export const mainCounter = state => state.counters.main



// WEBPACK FOOTER //
// ./src/store/getters.js